import { render } from "./QuoteDocumentTranslation.vue?vue&type=template&id=5e29d5ca&scoped=true"
import script from "./QuoteDocumentTranslation.vue?vue&type=script&lang=js"
export * from "./QuoteDocumentTranslation.vue?vue&type=script&lang=js"

import "./QuoteDocumentTranslation.vue?vue&type=style&index=0&id=5e29d5ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e29d5ca"

export default script